<template>
    <div>
        <div class="object-titlebox">
            <div class="object-titlebox-left" v-t="'message.title_link_setting'"></div>
        </div>

        <template v-if="!FEATURE_JKC_C2C_ADMIN_USER_CHANGE">
            <template v-if="appData.isRadioAdminOnlyUser">
                <div style="padding: 10px 10px 10px 20px;">{{ $t('message.info_need_not_to_be_radiomanager') }}</div>
            </template>
            <template v-else>
                <div class="no-data-message__hint" v-html="$t('message.hint_menu_link_tenant')"></div>
            </template>
        </template>

        <template v-else>
            <div class="no-data-message">
                <div class="no-data-message__hint" v-html="$t('message.hint_menu_link_tenant')"></div>
            </div>
        </template>
    </div>
</template>

<script>
import { FEATURE_JKC_C2C_ADMIN_USER_CHANGE } from "@/components/feature_toggles/feature_toggle";

export default {
    props: ['appData'],
    computed: {
        FEATURE_JKC_C2C_ADMIN_USER_CHANGE() {
            return FEATURE_JKC_C2C_ADMIN_USER_CHANGE;
        },
    },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.object-value {
    padding: 10px 10px;
}

.object-title {
    padding: 10px 10px;
    font-size: 12px;
}

.icon-help {
    height: 14px;
}

.title-box-right {
    position: relative;
    text-align: right;
    vertical-align: middle;
    font-size: 12px;
    float: right;
}

.title-box-left {
    padding: 10px;
    padding-left: 20px;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
}
</style>
